import { getUint8ArrayFromBlob, u8arrayToStr, inflate } from "./utils.js";
import axios from "axios";
import { ObjectLoader, Group } from "three";
import { IFCLoader } from "three/examples/jsm/loaders/IFCLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";

import { clientjs_host, draco_decoderPath } from "../../global.js";
let host = clientjs_host;


/**
 * 
 * @module api 客户端api
 */

/**
 *  切换服务，可选
 *  http://10.1.39.128:8080
 *  http://ic.toone.com.cn    //2-5 nginx外网
 *
 * @export
 * @param {String} h
 */
export function setHost(h) {
    host = h;
}

/** 
 * 
 * @type {THREE.ObjectLoader}
 * 
 **/
const objectLoader = new ObjectLoader();

/** 
 * 
 * @type {THREE.IFCLoader}
 * 
 **/
const ifcLoader = new IFCLoader();

/** @type {THREE.GLTFLoader} */
const gltfLoader = new GLTFLoader();

/** @type {THREE.DRACOLoader} */
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath(draco_decoderPath);
//dracoLoader.setDecoderConfig({type: 'js'}); // (Optional) Override detection of WASM support.
gltfLoader.setDRACOLoader(dracoLoader);





/**
 *拆分Blob,逐个生成meshs并合成一个Group，拆分依赖具体数据格式，数据格式依赖具体服务端实现，现在的数据格式是len+content，其中len占4个字节，content用zlib压缩过
 *
 * @export
 * @param {Blob} blob 
 * @param {Function} progress 进度回调
 * @return {Promise} 
 */
export async function extractGroupFromBlob(blob, progress) {
    let _32 = 4;//32位4字节 存byteLength信息
    let offset = 0;//逐步读blob
    let bytelen = blob.size;//所有blob的长度
    let group = new Group();
    let c = 1;
    while (true) {
        let len = blob.slice(offset, offset + _32); offset += _32;
        len = await getUint8ArrayFromBlob(len);
        len = new DataView(len.buffer).getUint32(0, true);//取 content前面的byteLength信息，4字节

        let content = blob.slice(offset, offset + len); offset += len;
        content = await getUint8ArrayFromBlob(content);

        content = inflate(content);
        let jsonStr = await u8arrayToStr(content);//从u8取jsonStr
        let jsonObj = JSON.parse(jsonStr);
        let mesh = objectLoader.parse(jsonObj);
        group.add(mesh);
        //----------------------------------
        if (progress) {
            let p = ((offset / bytelen) * 100) + "%";
            progress({ progress: p, offset: offset, bytelen: bytelen, count: c })
            c++;
        }
        //--------------------------------------------
        if (offset >= bytelen) break;//取完跳出
    }
    return group;
};

/**
 *根据userid,modelid取到对应模型，返回THREE.Group
 *
 * @export
 * @param {String} userid 用户id
 * @param {String} modelid 模型id
 * @param {String} [meshid=""] meshid
 * @param {Function} progress 进度回调
* @return {Promise}
 */
export async function getModel(userid, modelid, meshid = "", progress) {
    let start = new Date().getTime();
    let group = null;
    if (userid && modelid) {
        let url = host + "/three/queryModelData/" + userid + "/" + modelid + "/"; //http://10.1.39.128:8080/three/queryModelData/:userid/:modelid/:meshid
        url = meshid ? url + meshid : url;
        let instance = axios.create({
            responseType: "blob",
            method: "get",
            baseURL: url,
        });
        try {
            let val = await instance({});
            let blob = val.data;
            group = await extractGroupFromBlob(blob, progress);
        } catch (err) {
            console.log(err);
        }
    }
    let end = new Date().getTime();
    let d = end - start;
    console.log("执行时间：" + d);
    return group;
};

/**
 *取ifc模型
 *
 * @export
 * @param {String} userid 用户id
 * @param {String} modelid 模型id
 * @return {Promise} 
 */
export async function getIFCModel(userid, modelid) {
    let group = null;
    if (userid && modelid) {
        let url = host + "/three/queryRawModelData/" + userid + "/" + modelid; //http://10.1.39.128:8080/three/queryRawModelData/:userid/:modelid
        let instance = axios.create({
            responseType: "arraybuffer",
            method: "get",
            baseURL: url,
        });
        try {
            let val = await instance({});
            let arraybuf = val.data;
            let mid = ifcLoader.ifcManager.parser.currentModelID;
            if (mid > -1) ifcLoader.ifcManager.close(mid);
            group = await ifcLoader.parse(arraybuf);
        } catch (err) {
            console.log(err);
        }
    }
    return group;
}

/**
 *
 *取模型属性 
 * @export
 * @param {String} userid 用户id
 * @param {String} modelid 模型id
 * @return {Promise} 
 */
export async function getProps(userid, modelid) {
    let props = null;
    if (userid && modelid) {
        let url = host + "/three/queryProps/" + userid + "/" + modelid;
        let instance = axios.create({
            responseType: "json",
            method: "get",
            baseURL: url,
        });
        try {
            let val = await instance({});
            props = val;
        } catch (err) {
            console.log(err);
        }
    }
    return props;
};


/**
 *取模型树数据
 *
 * @export
 * @param {String} userid
 * @param {String} modelid
 * @return {Promise} 
 */
export async function getTreeNodes(userid, modelid) {
    let treeNodes = null;
    if (userid && modelid) {
        let url = host + "/three/queryTreeNodes/" + userid + "/" + modelid;
        let instance = axios.create({
            responseType: "json",
            method: "get",
            baseURL: url,
        });
        try {
            let val = await instance({});
            treeNodes = val;
        } catch (err) {
            console.log(err);
        }
    }
    return treeNodes;
};



/**
 *删除模型
 *
 * @export
 * @param {String} userid 用户id
 * @param {String} modelid 模型id
 * @return {Promise} 
 */
export async function deleteModel(userid, modelid) {
    let ret = null;
    if (userid && modelid) {
        let url = host + "/three/deleteModel/" + userid + "/" + modelid;
        let instance = axios.create({
            responseType: "json",
            method: "get",
            baseURL: url,
        });
        try {
            let val = await instance({});
            ret = val;
        } catch (err) {
            console.log(err);
        }
    }
    return ret;
};


/**
 *
 *批量取模型数据
 *
 * @export
 * @param {Array} arrayData  [uuid,uuid,...]
 * @param {Function} progress 进度回调
 * @return {Promise} 
 */
export async function batQueryModelData(arrayData, progress) {
    let start = new Date().getTime();
    let url = host + "/three/batQueryModelData";
    let instance = axios.create({
        responseType: "blob",
        method: "post",
        baseURL: url
    });
    //let instance = axios.post(url, { responseType: "blob", data: arrayData });
    let group = null;
    try {
        let val = await instance({ data: arrayData });
        let blob = val.data;
        if (blob.size > 0) {
            group = await extractGroupFromBlob(blob, progress);
        }
    } catch (err) {
        console.log(err);
    }
    let end = new Date().getTime();
    let d = end = start;
    console.log("执行时间：" + d);
    return group;
};

/**
 *查询模型文件上传转换的进度
 *
 * @export
 * @param {String} modelid
 * @return {Promise} 
 */
export async function checkStatus(modelid) {
    let ret = null;
    if (modelid) {
        let url = host + "/three/checkStatus/" + modelid;    //http://10.1.39.128:8080/three/checkStatus/:modelid
        let instance = axios.create({
            responseType: "json",
            method: "get",
            baseURL: url,
        });
        try {
            let val = await instance({});
            ret = val;
        } catch (err) {
            console.log(err);
        }
    }
    return ret;
};




/*
 *取gltf/glb模型
 *
 * @export
 * @param {String} userid
 * @param {String} modelid
 * @return {Promise} 
 */
export async function getGltfModel(userid, modelid) {
    let group = null;
    if (userid && modelid) {
        let url = host + "/three/queryRawModelData/" + userid + "/" + modelid; //http://10.1.39.128:8080/three/queryRawModelData/:userid/:modelid
        let instance = axios.create({
            responseType: "blob",
            method: "get",
            baseURL: url,
        });
        try {
            let val = await instance({});
            let blob = val.data;
            let arraybuf = await blob.arrayBuffer();
            let promise = new Promise(function (resolve, reject) {
                gltfLoader.parse(arraybuf, "", function (val) {
                    resolve(val);
                }, function (err) {
                    reject(err);
                });
            });
            group = await promise;
        } catch (err) {
            console.log(err);
        }
    }
    if (group) {
        group = group.scenes;
    }
    return group;
}